if (typeof WDN.Modal === "undefined") {
  WDN.Modal = (function () {
    var Init, Create, Modal, ListenForNewModals;
    var _validateMutationNodes;
    var body = document.querySelector("body");
    var Modals = document.querySelectorAll("[data-modal]");
    var List = {};

    var Config = {
      state: {
        open: "open",
        close: "closed",
      },
      version: "2.0.0",
    };

    Modal = function (id) {
      this.id = id;
      this.modal = document.querySelector("[data-modal='" + id + "']");
      this.openers = document.querySelectorAll("[data-modal-open='" + id + "']");
      this.closers = document.querySelectorAll("[data-modal-close='" + id + "']");
      this.isActive = false;
      this.init();
    };

    Modal.prototype.init = function () {
      this.bind();
    };

    Modal.prototype.bind = function () {
      this.bindOpeners();
      this.bindClosers();
    };

    Modal.prototype.bindOpeners = function () {
      this.openers.forEach(function (opener) {
        opener.addEventListener("click", this.openerOnClick.bind(this));
      }, this);
    };

    Modal.prototype.bindClosers = function () {
      this.closeOnKeyBound = this.closeOnEscape.bind(this);
      this.closeOnClickBound = this.closeOnClick.bind(this);
      this.closers.forEach(function (closer) {
        closer.addEventListener("click", this.closerOnClick.bind(this));
      }, this);
    };

    Modal.prototype.openerOnClick = function (e) {
      e ? e.preventDefault() : "";
      this.open();
    };

    Modal.prototype.closerOnClick = function (e) {
      e ? e.preventDefault() : "";
      this.close();
    };

    Modal.prototype.setActive = function () {
      this.isActive = true;
      this.modal.dataset.state = Config.state.open;
    };

    Modal.prototype.setInactive = function () {
      this.isActive = false;
      this.modal.dataset.state = Config.state.close;
    };

    Modal.prototype.toggleBodyClass = function () {
      if (this.isActive) {
        body.classList.add("Modal--open");
      } else {
        body.classList.remove("Modal--open");
      }
    };

    Modal.prototype.bindWindowEvents = function () {
      this._addEvent("keydown", this.closeOnKeyBound);
      this._addEvent("click", this.closeOnClickBound);
    };

    Modal.prototype.unbindWindowEvents = function () {
      this._removeEvent("keydown", this.closeOnKeyBound);
      this._removeEvent("click", this.closeOnClickBound);
    };

    Modal.prototype.closeOnEscape = function (e) {
      e ? e.preventDefault() : "";
      if (e.keyCode == 27) {
        this.close();
      }
    };

    Modal.prototype.closeOnClick = function (e) {
      e ? e.preventDefault() : "";
      if (e.target === this.modal) {
        this.close();
      }
    };

    Modal.prototype.close = function () {
      this.setInactive();
      this.onClose();
    };

    Modal.prototype.onClose = function () {
      this.onStateChange();
      this.unbindWindowEvents();
      this.callCloseCallback();
    };

    Modal.prototype.open = function () {
      this.setActive();
      this.onOpen();
    };

    Modal.prototype.onOpen = function () {
      this.onStateChange();
      this.bindWindowEvents();
      this.callOpenCallback();
    };

    Modal.prototype.onStateChange = function () {
      this.toggleBodyClass();
      this._fireCustomEvent();
    };

    Modal.prototype.callCloseCallback = function () {
      if (this.callbacks)
        if (this.callbacks.close) {
          this.callbacks.close.call(this);
        }
    };

    Modal.prototype.callOpenCallback = function () {
      if (this.callbacks)
        if (this.callbacks.open) {
          this.callbacks.open.call(this);
        }
    };

    Modal.prototype._fireCustomEvent = function () {
      var state = this.isActive ? Config.state.open : Config.state.close;
      var eventName = "modal:" + state;
      var detail = {
        modal: this,
      };
      var StateChangeEvent = new CustomEvent(eventName, {
        detail: detail,
      });

      body.dispatchEvent(StateChangeEvent);
      this.modal.dispatchEvent(StateChangeEvent);
    };

    Modal.prototype._addEvent = function (event, func) {
      return window.addEventListener(event, func);
    };

    Modal.prototype._removeEvent = function (event, func) {
      return window.removeEventListener(event, func);
    };

    Create = function (id, config) {
      if (id) {
        if (!List[id] || config.force_init) {
          List[id] = new Modal(id);
        }
      } else {
        console.warn("Failed to init new Modal with ID:" + id);
      }
    };

    Init = function (config) {
      Modals.forEach(function (modal) {
        var modalId = modal.dataset.modal;
        Create(modalId, config);
      });

      if (config && config.observer) {
        ListenForNewModals();
      }
    };

    ListenForNewModals = function () {
      var DomObserver = new MutationObserver(function (mutation) {
        mutation.forEach(function (record) {
          _validateMutationNodes(record.addedNodes);
        });
      });
      DomObserver.observe(body, {
        childList: true,
        characterData: true,
        attributes: true,
      });
    };

    _validateMutationNodes = function (nodes) {
      nodes.forEach(function (node) {
        if (node.dataset && node.dataset.modal) {
          Create(node.dataset.modal);
        }
      });
    };

    return {
      Init: Init,
      Create: Create,
      List: List,
      ListenForNewModals: ListenForNewModals,
      Version: Config.version,
    };
  })();
}

if (typeof WDN.Drawer === "undefined") {
  WDN.Drawer = (function () {
    // Public available
    var List, Init;

    // Private var
    var Config, Body, Drawers;

    Body = document.querySelector("body");
    Drawers = document.querySelectorAll(`[data-drawer]`);

    // List to hold generated objects, to allow access in global scope
    List = {};

    Config = {
      bodyOpen: "Drawer--open",
      openVertical: "Drawer--open-vertical",
      openHorizontal: "Drawer--open-horizontal",
      state: {
        opened: "opened",
        closed: "closed",
      },
      Version: "2.0.2",
    };

    var Constructor = function (id) {
      this.id = id;
      this.drawer = document.querySelector(`[data-drawer='${id}']`);
      this.openers = document.querySelectorAll(`[data-drawer-open='${id}']`);
      this.closers = document.querySelectorAll(`[data-drawer-close='${id}']`);
      this.state = Config.state.closed;
      this.closeOnKeyBound = this.closeOnEscape.bind(this);
      this.closeOnClickBound = this.closeOnClick.bind(this);
      this.init();
    };

    Constructor.prototype.closeOnEscape = function (e) {
      if (e.keyCode == 27) {
        this.close();
      }
    };

    Constructor.prototype.closeOnClick = function (e) {
      if (e.target.hasAttribute("data-drawer-open") || e.target.hasAttribute("data-drawer-close")) {
        e.preventDefault();
      }
      if (e.target.classList.contains(Config.bodyOpen)) {
        this.close();
      }
    };

    Constructor.prototype.init = function () {
      this.findAnimation();
      this.bind();
    };

    Constructor.prototype.bind = function () {
      this.bindClosers();
      this.bindOpeners();
    };

    Constructor.prototype.bindClosers = function () {
      this.closers.forEach(function (link) {
        link.addEventListener("click", this.close.bind(this));
      }, this);
    };

    Constructor.prototype.bindOpeners = function () {
      this.openers.forEach(function (link) {
        link.addEventListener("click", this.open.bind(this));
      }, this);
    };

    Constructor.prototype._addEvent = function (event, func) {
      return window.addEventListener(event, func);
    };

    Constructor.prototype._removeEvent = function (event, func) {
      return window.removeEventListener(event, func);
    };

    // State updater
    Constructor.prototype._stateOnUpdate = function () {
      if (this.state === Config.state.closed) {
        this.clearOpenState();
      } else {
        this.setOpenState();
      }
    };

    Constructor.prototype.setOpenState = function () {
      this.drawer.setAttribute("data-open", "");
      this.drawer.classList.add(this.currentAnimation);
      Body.classList.add(Config.bodyOpen);
    };

    Constructor.prototype.clearOpenState = function () {
      this.drawer.removeAttribute("data-open");
      this.drawer.classList.remove(this.currentAnimation);
      Body.classList.remove(Config.bodyOpen);
    };

    Constructor.prototype.findAnimation = function () {
      switch (this.drawer.dataset.animate) {
        case "top":
        case "bottom":
          this.currentAnimation = Config.openVertical;
          break;
        case "left":
          this.currentAnimation = Config.openHorizontal;
          break;
        default:
          this.currentAnimation = Config.openHorizontal;
      }
    };

    Constructor.prototype.bindEvents = function () {
      this._addEvent("keydown", this.closeOnKeyBound);
      this._addEvent("click", this.closeOnClickBound);
    };

    Constructor.prototype.removeEvents = function () {
      this._removeEvent("keydown", this.closeOnKeyBound);
      this._removeEvent("click", this.closeOnClickBound);
    };

    Constructor.prototype.stateUpdate = function (state) {
      this.state = state;
      this._stateOnUpdate();
      this._fireCustomEvent();
    };

    Constructor.prototype._fireCustomEvent = function () {
      var eventName = "drawer:" + this.state;
      var detail = {
        drawer: this,
      };
      var StateChangeEvent = new CustomEvent(eventName, {
        detail: detail,
      });
      Body.dispatchEvent(StateChangeEvent);
      this.drawer.dispatchEvent(StateChangeEvent);
    };

    Constructor.prototype.onOpen = function () {
      if (this.callbacks) {
        if (this.callbacks.open) {
          this.callbacks.open.call(this);
        }
      }
    };

    Constructor.prototype.onClose = function () {
      if (this.callbacks) {
        if (this.callbacks.close) {
          this.callbacks.close.call(this);
        }
      }
    };

    Constructor.prototype.open = function (e) {
      e ? e.preventDefault() : "";
      this.stateUpdate(Config.state.opened);
      this.bindEvents();
      this.onOpen();
    };

    Constructor.prototype.close = function (e) {
      e ? e.preventDefault() : "";
      this.stateUpdate(Config.state.closed);
      this.removeEvents();
      this.onClose();
    };

    var Create = function (id) {
      var Obj = new Constructor(id);
      List[id] = Obj;
    };

    var Init = function (obj) {
      if (Drawers.length > 0) {
        Drawers.forEach(function (Drawer) {
          if (typeof Drawer.dataset.drawer !== "undefined") {
            Create(Drawer.dataset.drawer);
          }
        });
        if (obj && obj.observer) {
          ListenForNewDrawers();
        }
      }
    };

    var CloseAll = function () {
      for (var key in List) {
        if (List.hasOwnProperty(key)) {
          var _Drawer = List[key];
          if (_Drawer.state === Config.state.opened) {
            _Drawer.close();
          }
        }
      }
    };

    var ListenForNewDrawers = function () {
      var DomObserver = new MutationObserver(function (mutation) {
        mutation.forEach(function (record) {
          _validateMutationNodes(record.addedNodes);
        });
      });
      DomObserver.observe(Body, {
        childList: true,
        characterData: true,
        attributes: true,
      });
    };

    var _validateMutationNodes = function (nodes) {
      nodes.forEach(function (node) {
        if (node.dataset && node.dataset.drawer) {
          Create(node.dataset.drawer);
        }
      });
    };

    return {
      Init: Init,
      CloseAll: CloseAll,
      ListenForNewDrawers: ListenForNewDrawers,
      List: List,
      Version: Config.Version,
    };
  })();
}
